export default __webpack_public_path__ + "static/media/transactions.cafeea33.svg";